/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddTeamNoteRequest
 */
export interface AddTeamNoteRequest {
  /**
   *
   * @type {string}
   * @memberof AddTeamNoteRequest
   */
  teamMemberId: string;
  /**
   *
   * @type {string}
   * @memberof AddTeamNoteRequest
   */
  body: string;
}

/**
 * Check if a given object implements the AddTeamNoteRequest interface.
 */
export function instanceOfAddTeamNoteRequest(
  value: object,
): value is AddTeamNoteRequest {
  if (!("teamMemberId" in value) || value["teamMemberId"] === undefined)
    return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function AddTeamNoteRequestFromJSON(json: any): AddTeamNoteRequest {
  return AddTeamNoteRequestFromJSONTyped(json, false);
}

export function AddTeamNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddTeamNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    teamMemberId: json["teamMemberId"],
    body: json["body"],
  };
}

export function AddTeamNoteRequestToJSON(json: any): AddTeamNoteRequest {
  return AddTeamNoteRequestToJSONTyped(json, false);
}

export function AddTeamNoteRequestToJSONTyped(
  value?: AddTeamNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    teamMemberId: value["teamMemberId"],
    body: value["body"],
  };
}
